<template>
    <div class="ls-order">
        <div class="ls-order__top ls-card">
            <el-form ref="form" inline :model="form" size="small">
                <el-form-item label="商户">
                    <el-select v-model="form.sid" placeholder="全部" filterable>
                        <el-option label="全部" value=""></el-option>
                        <el-option
                            v-for="(item, index) in shopList"
                            :key="index"
                            :label="item.name"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="创建时间">
                    <div class="flex">
                        <date-picker
                            size="small"
                            :start-time.sync="form.start_time"
                            :end-time.sync="form.end_time"
                        />
                    </div>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getOrderLists(1)">
                        查询
                    </el-button>
                    <el-button type="style" @click="reset"> 重置 </el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="ls-card m-t-16">
            <el-table :data="pager.lists" size="small">
                <el-table-column prop="order_sn" label="订单编号" />
                <el-table-column prop="out_id" label="外部订单ID" />
                <el-table-column prop="shop_name" label="商户名称" />
                <el-table-column prop="model" label="模型信息" width="500px">
                    <template slot-scope="{ row }">
                        <div class="flex row-left col-top p-8">
                            <el-image
                                class="model-image"
                                :src="row.model_image"
                            />
                            <div class="m-l-8">
                                <div class="lin-2 width-200">
                                    {{ row.model_name }}
                                </div>
                                <div>
                                    {{ row.spec_value_str }}
                                </div>
                                <div>
                                    <span v-if="row.source == 1">普通商品</span>
                                    <span v-if="row.source == 2">模型商品</span>
                                    <span v-if="row.source == 3"
                                        >后台设计器</span
                                    >/
                                    <span>
                                        {{
                                            row.order_type === 1
                                                ? "一项一件"
                                                : row.order_type === 2
                                                ? "一项多件"
                                                : row.order_type === 3
                                                ? "多项多件"
                                                : ""
                                        }}
                                    </span>
                                </div>
                                <div>x{{ row.number }}</div>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="create_time" label="创建时间" />
            </el-table>
            <div class="m-t-24 flex row-right">
                <ls-pagination v-model="pager" @change="getOrderLists()" />
            </div>
        </div>
    </div>
</template>
<script>
import { RequestPaging } from "@/utils/util";
import { apiOrderShopOrderLists } from "@/api/order";
import { apiShopLists } from "@/api/shop";
import DatePicker from "@/components/date-picker.vue";
import LsPagination from "@/components/ls-pagination.vue";
export default {
    components: {
        DatePicker,
        LsPagination,
    },
    data() {
        return {
            pager: new RequestPaging(),
            form: {
                start_time: "",
                end_time: "",
                sid: ""
            },
            shopList: [],
        };
    },
    methods: {
        getOrderLists(page) {
            page && (this.pager.page = page);
            this.pager
                .request({
                    callback: apiOrderShopOrderLists,
                    params: {
                        ...this.form,
                    },
                })
                .then((res) => {});
        },
        reset() {
            this.form.start_time = "";
            this.form.end_time = "";
            this.form.sid = "";
            this.getOrderLists();
        },
        getShopList() {
            apiShopLists({
                page_type: 0
            }).then((res) => {
                this.shopList = res.lists;
            });
        },
    },
    created() {
        this.getOrderLists();
        this.getShopList();
    },
};
</script>
<style lang="scss">
.width-200 {
    width: 200px;
}
.p-8 {
    padding: 8px;
}
.model-image {
    width: 100px;
    height: 100px;
}
</style>
